var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('scanner-modal',{attrs:{"start":_vm.start},on:{"setBarCode":_vm.setBarCode}}),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.showModal}},[_c('i',{staticClass:"icon-camera"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }